import { BaseModel } from "@/models/base.model.ts"
import type { IIncomingInvoiceRentalIntakeMaterialization } from "@/interfaces/api/incoming-invoice-rental-intake-materialization.interface.ts"

export class IncomingInvoiceRentalIntakeMaterialization
  extends BaseModel
  implements IIncomingInvoiceRentalIntakeMaterialization
{
  public static className = "IncomingInvoiceRentalIntakeMaterialization"
  public static verboseName = "Inkoopfactuur-inhuurmaterialisatie"

  incomingInvoiceReference: string

  incomingInvoice: string
  rentalIntakeMaterialization: string
  quantity: string

  constructor(
    incomingInvoiceRentalIntakeMaterialization: IIncomingInvoiceRentalIntakeMaterialization
  ) {
    super(incomingInvoiceRentalIntakeMaterialization)

    this.incomingInvoiceReference =
      incomingInvoiceRentalIntakeMaterialization.incomingInvoiceReference

    this.incomingInvoice = incomingInvoiceRentalIntakeMaterialization.incomingInvoice
    this.rentalIntakeMaterialization =
      incomingInvoiceRentalIntakeMaterialization.rentalIntakeMaterialization
    this.quantity = incomingInvoiceRentalIntakeMaterialization.quantity
  }
}
